import styled from 'styled-components';
import getIn from 'lodash/get';
import breakpoints from 'utils/breakpoints';

export default styled.h4`
  color: ${props => getIn(props, 'theme.heading.textColor', '#1c2f45')};
  font-family: Helvetica;
  font-weight: bold;
  font-size: 1.13rem;
  line-height: 1.38rem;
  margin: 0.75rem 0;
  @media screen and (min-width: ${breakpoints.md}) {
    margin: 1.5rem 0;
    font-size: 1.5rem;
    line-height: 1.81rem;
  }
`;
